
export default function Footer() {
  return (
    <footer className="bg-emerald-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <i className="ri-building-4-line text-2xl"></i>
              <span className="text-xl font-bold">合同会社フジワン</span>
            </div>
            <p className="text-emerald-100 leading-relaxed">
              内装工事のトータルサポートを提供する専門企業です。お客様の理想を形にします。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">サービス</h4>
            <ul className="space-y-2 text-emerald-100">
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  設計・監理サービス
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  材料選定コンサルティング
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  オンライン講座・セミナー
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  トータルサポート
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">会社情報</h4>
            <ul className="space-y-2 text-emerald-100">
              <li>埼玉県春日部市藤塚1897番地4</li>
              <li>設立：令和6年10月9日</li>
              <li>営業時間：平日 9:00 - 18:00</li>
              <li>
                <a href="/privacy" className="hover:text-white transition-colors cursor-pointer underline">
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-emerald-800 pt-8 text-center text-emerald-100">
          <p>&copy; 2024 合同会社フジワン. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
